import React from 'react';
import { Grid, FormControl, Select, MenuItem, Button, Box, Typography } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import RefreshIcon from '@mui/icons-material/Refresh';
import { t } from '../../../utils/textUtils';
import { extractRomanNumeral } from '../utils/formatters';

const CategorySelector = ({
  categoryList,
  selectedBangunan,
  selectedCategory,
  isUnitMode,
  isProjectMode,
  onCategoryChange,
  onReset,
  selectedProject
}) => {
  const sortedCategoryList = [...categoryList].sort((a, b) => {
    const aOrder = extractRomanNumeral(a.kategori || a.name);
    const bOrder = extractRomanNumeral(b.kategori || b.name);
    return aOrder - bOrder;
  });

  const isDisabled = !selectedBangunan || isUnitMode || isProjectMode;
  
  return (
    <>
      <Grid size={{ xs: 12, md: 3 }}>
        <Box>
          <Typography variant="caption" sx={{ fontWeight: 600, color: isDisabled ? '#CBD5E1' : '#475569', mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: isDisabled ? '#CBD5E1' : '#0f172a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, flexShrink: 0 }}>3</Box>
            {t('PILIH KATEGORI')}
            <Typography component="span" variant="caption" sx={{ color: '#94A3B8', fontStyle: 'italic', fontWeight: 400 }}>(opsional)</Typography>
          </Typography>
          <FormControl fullWidth disabled={isDisabled}>
            <Select
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e.target.value)}
              displayEmpty
              startAdornment={<CategoryIcon sx={{ color: isDisabled ? '#CBD5E1' : '#94A3B8', mr: 1, fontSize: 18 }} />}
              renderValue={(selected) => {
                const category = sortedCategoryList.find(c => c.id === selected);
                return category
                  ? <Typography variant="body2" sx={{ fontWeight: 600, color: '#0f172a' }}>{category.name}</Typography>
                  : <Typography variant="body2" sx={{ color: isDisabled ? '#CBD5E1' : '#94A3B8' }}>{t('PILIH KATEGORI')}</Typography>;
              }}
              sx={{
                borderRadius: 2,
                bgcolor: '#F8FAFC',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: isDisabled ? '#E2E8F0' : '#94A3B8' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0f172a' }
              }}
            >
              <MenuItem value=""><em>{t('PILIH KATEGORI')}</em></MenuItem>
              {sortedCategoryList.map((category) => (
                <MenuItem key={category.id} value={category.id}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{category.name}</Typography>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, md: 1.5 }}>
        <Box>
          <Typography variant="caption" sx={{ opacity: 0, display: 'block', mb: 0.5 }}>.</Typography>
          <Button
            fullWidth
            variant="outlined"
            onClick={onReset}
            disabled={!selectedCategory && !selectedBangunan && !selectedProject}
            startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
            sx={{
              height: '40px',
              borderColor: '#E2E8F0',
              color: '#64748B',
              borderRadius: 2,
              fontWeight: 600,
              fontSize: '0.8rem',
              '&:hover': { borderColor: '#EF4444', color: '#EF4444', bgcolor: '#FEF2F2' },
              '&.Mui-disabled': { borderColor: '#E2E8F0', color: '#CBD5E1' }
            }}
          >
            {t('RESET')}
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default CategorySelector;
